<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.ev_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.ev_evaluate">
                      <el-input type="number" v-model="mData.tableRules.dataSearch.value.gia_tri" clearable min="0" />
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.ev_created_time" prop="thoi_diem_tao">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_diem_tao"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia"
                    :placeholder="aLang.ev_evaluation_object_type"
                    :disabled="mData.viewMode == 'detail'"
                    @change="fn_changeLoaiDoiTuong()"
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listLoaiDoiTuongDanhGia"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>

                </b-col>
                <b-col md="8">
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id"
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    clearable
                    filterable
                    placeholder="Nhập tên tour (nhấn enter để tìm kiếm)"
                    no-data-text="Chưa có dữ liệu"
                    :filter-method="fn_remoteGetListDoiTuong"
                    @keyup.enter.native="fn_enterFindDoiTuong()"
                    @change="fn_tableSearch()"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='tour'||mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindDoiTuongDanhGia"
                      :key="item.id"
                      :label="item.ten_tour"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                        v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='tour'||mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                        :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                        clearable
                        class="inline-input"
                        v-model="loai_doi_tuong_danh_gia"
                        :fetch-suggestions="querySearchLoaiDoiTuongDanhGia"
                        :placeholder="aLang.ev_enter_tour_name"
                        @select="handleSelectLoaiDoiTuongDanhGiaTenTour"
                        @change="handleSelectLoaiDoiTuongDanhGiaTenTour"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten_tour }}</span>
                        </template>
                  </el-autocomplete>
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id"
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    clearable
                    filterable
                    placeholder="Nhập tên hướng dẫn viên (nhấn enter để tìm kiếm)"
                    no-data-text="Chưa có dữ liệu"
                    :filter-method="fn_remoteGetListDoiTuong"
                    @keyup.enter.native="fn_enterFindDoiTuong()"
                    @change="fn_tableSearch()"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='tour_guide'"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindDoiTuongDanhGia"
                      :key="item.id"
                      :label="item.ho_ten.ho_ten"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                        v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='tour_guide'"
                        :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                        clearable
                        class="inline-input"
                        v-model="loai_doi_tuong_danh_gia"
                        :fetch-suggestions="querySearchLoaiDoiTuongDanhGia"
                        :placeholder="aLang.ev_enter_tour_guide_name"
                        @select="handleSelectLoaiDoiTuongDanhGia"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                  </el-autocomplete>
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id"
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    clearable
                    filterable
                    placeholder="Nhập tên dịch vụ du lịch (nhấn enter để tìm kiếm)"
                    no-data-text="Chưa có dữ liệu"
                    :filter-method="fn_remoteGetListDoiTuong"
                    @keyup.enter.native="fn_enterFindDoiTuong()"
                    @change="fn_tableSearch()"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='hq_service'"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindDoiTuongDanhGia"
                      :key="item.id"
                      :label="item.ten.vi"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='hq_service'"
                        clearable
                        class="inline-input"
                        v-model="loai_doi_tuong_danh_gia"
                        :fetch-suggestions="querySearchLoaiDoiTuongDanhGia"
                        :placeholder="aLang.ev_enter_travel_service_name"
                        @select="handleSelectLoaiDoiTuongDanhGia"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten.vi }}</span>
                        </template>
                  </el-autocomplete>
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id"
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    clearable
                    filterable
                    placeholder="Nhập tên điểm đến (nhấn enter để tìm kiếm)"
                    no-data-text="Chưa có dữ liệu"
                    :filter-method="fn_remoteGetListDoiTuong"
                    @keyup.enter.native="fn_enterFindDoiTuong()"
                    @change="fn_tableSearch()"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='safe_place'"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindDoiTuongDanhGia"
                      :key="item.id"
                      :label="item.thong_tin_chung.ten"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='safe_place'"
                        clearable
                        class="inline-input"
                        v-model="loai_doi_tuong_danh_gia"
                        :fetch-suggestions="querySearchLoaiDoiTuongDanhGia"
                        :placeholder="aLang.ev_enter_safe_destination_name"
                        @select="handleSelectLoaiDoiTuongDanhGia"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.thong_tin_chung.ten }}</span>
                        </template>
                  </el-autocomplete>
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id"
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    clearable
                    filterable
                    placeholder="Nhập tên cơ sở lưu trú (nhấn enter để tìm kiếm)"
                    no-data-text="Chưa có dữ liệu"
                    :filter-method="fn_remoteGetListDoiTuong"
                    @keyup.enter.native="fn_enterFindDoiTuong()"
                    @change="fn_tableSearch()"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='accommodation'"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindDoiTuongDanhGia"
                      :key="item.id"
                      :label="item.ten.vi"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='accommodation'"
                        clearable
                        class="inline-input"
                        v-model="loai_doi_tuong_danh_gia"
                        :fetch-suggestions="querySearchLoaiDoiTuongDanhGia"
                        :placeholder="aLang.ev_enter_accommodation_name"
                        @select="handleSelectLoaiDoiTuongDanhGia"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten.vi }}</span>
                        </template>
                  </el-autocomplete>
                  <!-- <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id"
                    :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                    clearable
                    filterable
                    placeholder="Nhập tên khách du lịch (nhấn enter để tìm kiếm)"
                    no-data-text="Chưa có dữ liệu"
                    :filter-method="fn_remoteGetListDoiTuong"
                    @keyup.enter.native="fn_enterFindDoiTuong()"
                    @change="fn_tableSearch()"
                    v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='tourist'"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listFindDoiTuongDanhGia"
                      :key="item.id"
                      :label="item.ho_ten.ho_ten"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                  <el-autocomplete
                        v-if="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia=='tourist'"
                        :disabled="mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia==''"
                        clearable
                        class="inline-input"
                        v-model="loai_doi_tuong_danh_gia"
                        :fetch-suggestions="querySearchLoaiDoiTuongDanhGia"
                        :placeholder="aLang.ev_enter_tourists_name"
                        @select="handleSelectLoaiDoiTuongDanhGia"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                  </el-autocomplete>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
              <!-- <el-button @click="fn_handle('goBack')" type="info" plain>{{aLang.c_back}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ten_nguoi_danh_gia"
            :label="aLang.ev_assessor"
            min-width="200"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="doi_tuong_danh_gia_id"
            :label="aLang.ev_object_type"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.ten_loai_doi_tuong_danh_gia}}
            </template>
          </el-table-column>
          <el-table-column
            prop="doi_tuong_danh_gia_id"
            :label="aLang.ev_assessment_object"
            min-width="200"
          >
              <template slot-scope="scope">
              {{scope.row.ten_doi_tuong_danh_gia}}
            </template>
          </el-table-column>
          <el-table-column
            prop="gia_tri"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.ev_evaluate"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{fn_formatterNumber(scope.row.gia_tri,1)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.ev_created_time"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('Admin,Officer') && !['safe_place', 'tourist'].includes(scope.row.loai_doi_tuong_danh_gia)"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DanhGiaModel from "./DanhGiaModel";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";
import DanhGiaLogApi from "../../../moduleApi/DanhGiaLogApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import TourApi from "../../../moduleApi/TourApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import DichVuChatLuongCaoApi from "../../../moduleApi/DichVuChatLuongCaoApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";

export default {
  data() {
    return {
      loai_doi_tuong_danh_gia:'',
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DanhGia", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DanhGiaModel.tableRules),
        dataDefault: {
          listNguoiDanhGia: [],
          listNguoiDanhGiaHDV: [],
          listNguoiDanhGiaDDAT:[],
          listDoiTuongDanhGia: [],
          listTour: [],
          listHuongDanVien: [],
          listDichVuChatLuongCao: [],
          listDDAT:[],
          listCoSoLuuTru:[],
          listKhachDuLich: [],
          listFindDoiTuongDanhGia: [],
          listLoaiDoiTuongDanhGia: MethodService.copyObject(DanhGiaModel.loaiDoiTuongDanhGia),

          textFindDoiTuong: "",
        }
      }
    };
  },

  methods: {

    async querySearchLoaiDoiTuongDanhGia(queryString, cb) {
      queryString = queryString.trim();

    if(queryString){
          if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour") {

          let resDoiTuongApi = await TourApi.list({
            limit: 1000,
            filters: "ten_tour:regex_i:"+queryString
          });
          this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;

        } else {
          if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour_guide") {
            let resDoiTuongApi = await HuongDanVienApi.list({
              limit: 1000,
              filters: "ho_ten.ho_ten:regex_i:"+queryString
            });
            this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;

          } else {
            if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "hq_service") {
              let resDoiTuongApi = await DichVuChatLuongCaoApi.list({
                limit: 1000,
                filters: "ten.vi:regex_i:"+queryString
              });
              this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
            } else {
              if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "safe_place") {
                let resDoiTuongApi = await DiemDenAnToanApi.list({
                  limit: 1000,
                  filters: "thong_tin_chung.ten:regex_i:"+queryString
                });
                this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
              } else {
                if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "accommodation") {
                  let resDoiTuongApi = await CoSoLuuTruApi.list({
                    limit: 1000,
                    filters: "ten.vi:regex_i:"+queryString
                  });
                  this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                }
                else {
                  if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tourist") {
                    let resDoiTuongApi = await KhachDuLichApi.list({
                      limit: 1000,
                      filters: "ho_ten.ho_ten:regex_i:"+ queryString
                    });
                    this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                  }
                }
              }
            }
          }
        }
    }
      this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id=""
      if(queryString==""){
       this.fn_tableSearch()
      }
     if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour") {
          var results = queryString
        ? this.mData.dataDefault.listFindDoiTuongDanhGia.filter(
            item =>
              item.ten_tour.toLowerCase().includes(queryString.toLowerCase())
          )
        : []


        } else {
          if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour_guide") {
          var results = queryString
        ? this.mData.dataDefault.listFindDoiTuongDanhGia.filter(
            item =>
              item.ho_ten.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : []

          } else {
            if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "hq_service") {
              var results = queryString
        ? this.mData.dataDefault.listFindDoiTuongDanhGia.filter(
            item =>
              item.ten.vi.toLowerCase().includes(queryString.toLowerCase())
          )
        : []
            } else {
              if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "safe_place") {
                  var results = queryString
        ? this.mData.dataDefault.listFindDoiTuongDanhGia.filter(
            item =>
              item.thong_tin_chung.ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : []
              } else {
                if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "accommodation") {
                   var results = queryString
        ? this.mData.dataDefault.listFindDoiTuongDanhGia.filter(
            item =>
              item.ten.vi.toLowerCase().includes(queryString.toLowerCase())
          )
        : []
                }
                else {
                  if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tourist") {
                      var results = queryString
        ? this.mData.dataDefault.listFindDoiTuongDanhGia.filter(
            item =>
              item.ho_ten.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : []
                  }
                }
              }
            }
          }
        }

      // call callback function to return suggestions
      cb(results);
    },
    handleSelectLoaiDoiTuongDanhGia(item) {
    this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id  = item.id;
         if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour") {
          this.loai_doi_tuong_danh_gia =  item.ten_tour;

        } else {
          if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour_guide") {
            this.loai_doi_tuong_danh_gia =  item.ho_ten.ho_ten;


          } else {
            if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "hq_service") {
              this.loai_doi_tuong_danh_gia =  item.ten.vi;
            } else {
              if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "safe_place") {
              this.loai_doi_tuong_danh_gia =  item.thong_tin_chung.ten;
              } else {
                if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "accommodation") {
              this.loai_doi_tuong_danh_gia =  item.ten.vi;
                }
                else {
                  if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tourist") {
                    this.loai_doi_tuong_danh_gia =  item.ho_ten.ho_ten;
                  }
                }
              }
            }
          }
        }
      this.fn_tableSearch()
    },
    handleSelectLoaiDoiTuongDanhGiaTenTour(item) {
      this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id  = item.id;
      this.loai_doi_tuong_danh_gia =  item.ten_tour;
      this.fn_tableSearch()
    },
    //get list table
    async fn_initTable() {
      //Chỉ lấy theo các hdv đã dẫn cho tour
      // let resHDV = await HuongDanVienApi.getListHuongDanVienDaDan();
      // let huongDanVienIds = [];
      // huongDanVienIds = MethodService.findListItemDifferent(resHDV.result, "id");
      // this.mData.tableRules.filters="doi_tuong_danh_gia_id:in:"+huongDanVienIds.join(",");
      //
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = null;
      if (['safe_place', 'tourist'].includes(this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia)) {
        res = await DanhGiaLogApi.list(dataFilter);
      } else {
        res = await DanhGiaApi.list(dataFilter);
      }

      //get List
      let nguoiDanhGias = [];
      let doiTuongDanhGias = [];

      nguoiDanhGias = MethodService.findListItemDifferent(
        res.result,
        "nguoi_danh_gia_id"
      );

      doiTuongDanhGias = MethodService.findListItemDifferent(
        res.result,
        "doi_tuong_danh_gia_id"
      );

      let resNguoiDanhGiaKDLApi = await KhachDuLichApi.list({
        limit: nguoiDanhGias.length,
        filters: "id:in:" + nguoiDanhGias.join(",")
      });
      let resNguoiDanhGiaHDVApi = await HuongDanVienApi.list({
        limit: nguoiDanhGias.length,
        filters: "id:in:" + nguoiDanhGias.join(",")
      });

      let resNguoiDanhGiaDDATApi = await DiemDenAnToanApi.list({
        limit: nguoiDanhGias.length,
        filters: "nguoi_tao_id:in:" + nguoiDanhGias.join(",")
      });


      // let resDoiTuongDanhGiaApi =await KhachDuLichApi.list({ limit: khachDuLichIds.length, filters: "id:in:" + doiTuongDanhGias.join(",")});
      let resTourApi = await TourApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });
      let resHuongDanVienApi = await HuongDanVienApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });
      let resDichVuChatLuongCaoApi = await DichVuChatLuongCaoApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });
      let resDDATApi = await DiemDenAnToanApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });
      let resCoSoLuuTruApi = await CoSoLuuTruApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });
      let resKhachDuLichApi = await KhachDuLichApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });

      this.mData.dataDefault.listNguoiDanhGia = resNguoiDanhGiaKDLApi.result;
      this.mData.dataDefault.listNguoiDanhGiaHDV = resNguoiDanhGiaHDVApi.result;
      if (resNguoiDanhGiaDDATApi&&resNguoiDanhGiaDDATApi.result) {
        this.mData.dataDefault.listNguoiDanhGiaDDAT = resNguoiDanhGiaDDATApi.result;
      }

      // this.mData.dataDefault.listDoiTuongDanhGia = resDoiTuongDanhGiaApi.result;
      this.mData.dataDefault.listTour = resTourApi.result;
      this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;
      this.mData.dataDefault.listDichVuChatLuongCao = resDichVuChatLuongCaoApi.result;
      this.mData.dataDefault.listDDAT = resDDATApi.result;
      this.mData.dataDefault.listCoSoLuuTru = resCoSoLuuTruApi.result;
      this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
      //end

      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        let nguoiDanhGia = this.mData.dataDefault.listNguoiDanhGia.find(
          element => {
            return element.id == item.nguoi_danh_gia_id;
          }
        );
        if (nguoiDanhGia) {
          if(nguoiDanhGia.ho_ten && nguoiDanhGia.ho_ten.ho_ten && nguoiDanhGia.ho_ten.ho_ten.trim() != ""){
            item.ten_nguoi_danh_gia = nguoiDanhGia.ho_ten.ho_ten;
          }else{
            item.ten_nguoi_danh_gia = "Chưa có thông tin";
          }
        }
        else {
          let nguoiDanhGiaHDV = this.mData.dataDefault.listNguoiDanhGiaHDV.find(
            element => {
              return element.id == item.nguoi_danh_gia_id;
            }
          );
          if (nguoiDanhGiaHDV) {
            item.ten_nguoi_danh_gia = nguoiDanhGiaHDV.ho_ten.ho_ten;
          }
          else {
            let nguoiDanhGiaDDAT = this.mData.dataDefault.listNguoiDanhGiaDDAT.find(
              element => {
                return element.nguoi_tao_id == item.nguoi_danh_gia_id;
              }
            );
            if (nguoiDanhGiaDDAT) {
              item.ten_nguoi_danh_gia = nguoiDanhGiaDDAT.thong_tin_chung.ten;
            }
            else {
              item.ten_nguoi_danh_gia = "";
            }
          }
        }

        let loaiDoiTuongDanhGia = this.mData.dataDefault.listLoaiDoiTuongDanhGia.find(
          element => {
            return element.code == item.loai_doi_tuong_danh_gia;
          }
        );
        if (loaiDoiTuongDanhGia) {
          item.ten_loai_doi_tuong_danh_gia = loaiDoiTuongDanhGia.text;
        }

        if (item.loai_doi_tuong_danh_gia == "tour") {
          let doiTuongDanhGia = this.mData.dataDefault.listTour.find(
            element => {
              return element.id == item.doi_tuong_danh_gia_id;
            }
          );
          if (doiTuongDanhGia) {
            item.ten_doi_tuong_danh_gia = doiTuongDanhGia.ten_tour;
          }
        } else {
          if (item.loai_doi_tuong_danh_gia == "tour_guide") {
            let doiTuongDanhGia = this.mData.dataDefault.listHuongDanVien.find(
              element => {
                return element.id == item.doi_tuong_danh_gia_id;
              }
            );
            if (doiTuongDanhGia) {
              item.ten_doi_tuong_danh_gia = doiTuongDanhGia.ho_ten.ho_ten;
            }
          } else {
            if (item.loai_doi_tuong_danh_gia == "hq_service") {
              let doiTuongDanhGia = this.mData.dataDefault.listDichVuChatLuongCao.find(
                element => {
                  return element.id == item.doi_tuong_danh_gia_id;
                }
              );
              if (doiTuongDanhGia) {
                item.ten_doi_tuong_danh_gia = doiTuongDanhGia.ten.vi;
              }
            } else {
              if (item.loai_doi_tuong_danh_gia == "safe_place") {
                let doiTuongDanhGia = this.mData.dataDefault.listDDAT.find(
                  element => {
                    return element.id == item.doi_tuong_danh_gia_id;
                  }
                );
                if (doiTuongDanhGia) {
                  item.ten_doi_tuong_danh_gia = doiTuongDanhGia.thong_tin_chung.ten;
                }
              } else {
                if (item.loai_doi_tuong_danh_gia == "accommodation") {
                  let doiTuongDanhGia = this.mData.dataDefault.listCoSoLuuTru.find(
                    element => {
                      return element.id == item.doi_tuong_danh_gia_id;
                    }
                  );
                  if (doiTuongDanhGia) {
                    item.ten_doi_tuong_danh_gia = doiTuongDanhGia.ten.vi;
                  }
                } else {
                  if (item.loai_doi_tuong_danh_gia == "tourist") {
                    let doiTuongDanhGia = this.mData.dataDefault.listKhachDuLich.find(
                      element => {
                        return element.id == item.doi_tuong_danh_gia_id;
                      }
                    );
                    if (doiTuongDanhGia) {
                      if(doiTuongDanhGia.ho_ten && doiTuongDanhGia.ho_ten.ho_ten && doiTuongDanhGia.ho_ten.ho_ten.trim() != ""){
                        item.ten_doi_tuong_danh_gia = doiTuongDanhGia.ho_ten.ho_ten;
                      }else{
                        item.ten_doi_tuong_danh_gia = "Chưa có thông tin";
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
      return data;
    },


    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await DanhGiaApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await DanhGiaApi.disable(id, disable);
      this.fn_initTable();
    },


    fn_changeLoaiDoiTuong() {
      this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id=null;
      this.mData.dataDefault.textFindDoiTuong="";
      this.mData.dataDefault.listFindDoiTuongDanhGia=[];
      this.fn_tableSearch();
    },

    async fn_remoteGetListDoiTuong(query) {
      this.mData.dataDefault.textFindDoiTuong = query.trim();
    },
    async fn_enterFindDoiTuong() {
      this.mData.dataDefault.textFindDoiTuong = this.mData.dataDefault.textFindDoiTuong.trim();
      if (this.mData.dataDefault.textFindDoiTuong) {
        // let resHuongDanVienApi = await HuongDanVienApi.list({
        //   limit: 1000,
        //   filters: `the_hdv.so_the=${this.mData.dataDefault.textFindDoiTuong}`
        // });
        // this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;


        if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour") {

          let resDoiTuongApi = await TourApi.list({
            limit: 1000,
            filters: "ten_tour:regex_i:"+this.mData.dataDefault.textFindDoiTuong
          });
          this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;

        } else {
          if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tour_guide") {
            let resDoiTuongApi = await HuongDanVienApi.list({
              limit: 1000,
              filters: "ho_ten.ho_ten:regex_i:"+this.mData.dataDefault.textFindDoiTuong
            });
            this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
          } else {
            if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "hq_service") {
              let resDoiTuongApi = await DichVuChatLuongCaoApi.list({
                limit: 1000,
                filters: "ten.vi:regex_i:"+this.mData.dataDefault.textFindDoiTuong
              });
              this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
            } else {
              if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "safe_place") {
                let resDoiTuongApi = await DiemDenAnToanApi.list({
                  limit: 1000,
                  filters: "thong_tin_chung.ten:regex_i:"+this.mData.dataDefault.textFindDoiTuong
                });
                this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
              } else {
                if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "accommodation") {
                  let resDoiTuongApi = await CoSoLuuTruApi.list({
                    limit: 1000,
                    filters: "ten.vi:regex_i:"+this.mData.dataDefault.textFindDoiTuong
                  });
                  this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                }
                else {
                  if (this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia == "tourist") {
                    let resDoiTuongApi = await KhachDuLichApi.list({
                      limit: 1000,
                      filters: "ho_ten.ho_ten:regex_i:"+this.mData.dataDefault.textFindDoiTuong
                    });
                    this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                  }
                }
              }
            }
          }
        }
      }
      this.mData.dataDefault.textFindDoiTuong = "";
    },
    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value.gia_tri){
        this.mData.tableRules.dataSearch.value.gia_tri = this.mData.tableRules.dataSearch.value.gia_tri.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterNumber(cellValue, dec) {
      if (typeof cellValue == "number") {
        if (!(dec && typeof cellValue == "number")) dec = 0;
        return cellValue
          .toFixed(dec)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ",");
      }
    },

    async fn_initDataDefault() {
      if (this.aRole('TourAgent')){
        this.mData.dataDefault.listLoaiDoiTuongDanhGia.splice(2, 1);
      }
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }

      let doi_tuong_danh_gia_ID=this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id;
      let loai_doi_tuong_danh_gia_ID=this.mData.tableRules.dataSearch.value.loai_doi_tuong_danh_gia;
      if (doi_tuong_danh_gia_ID) {
        if (loai_doi_tuong_danh_gia_ID) {
          if (loai_doi_tuong_danh_gia_ID == "tour") {

            let resDoiTuongApi = await TourApi.list({
              limit: 1000,
              filters: "id="+doi_tuong_danh_gia_ID
            });
            this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
            // this.loai_doi_tuong_danh_gia = this.mData.dataDefault.listFindDoiTuongDanhGia?this.mData.dataDefault.listFindDoiTuongDanhGia[0].ten_tour:''

          } else {
            if (loai_doi_tuong_danh_gia_ID == "tour_guide") {
              let resDoiTuongApi = await HuongDanVienApi.list({
                limit: 1000,
                filters: "id="+doi_tuong_danh_gia_ID
              });
              this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
              // this.loai_doi_tuong_danh_gia = this.mData.dataDefault.listFindDoiTuongDanhGia?this.mData.dataDefault.listFindDoiTuongDanhGia[0].ho_ten.ho_ten:''
            } else {
              if (loai_doi_tuong_danh_gia_ID == "hq_service") {
                let resDoiTuongApi = await DichVuChatLuongCaoApi.list({
                  limit: 1000,
                  filters: "id="+doi_tuong_danh_gia_ID
                });
                this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
              } else {

                if (loai_doi_tuong_danh_gia_ID == "safe_place") {
                  let resDoiTuongApi = await DiemDenAnToanApi.list({
                    limit: 1000,
                    filters: "id="+doi_tuong_danh_gia_ID
                  });
                  this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                } else {
                  if (loai_doi_tuong_danh_gia_ID == "accommodation") {
                    let resDoiTuongApi = await CoSoLuuTruApi.list({
                      limit: 1000,
                      filters: "id="+doi_tuong_danh_gia_ID
                    });
                    this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                  }
                  else {
                    // debugger
                    if (loai_doi_tuong_danh_gia_ID == "tourist") {
                      let resDoiTuongApi = await KhachDuLichApi.list({
                        limit: 1000,
                        filters: "id="+doi_tuong_danh_gia_ID
                      });
                      this.mData.dataDefault.listFindDoiTuongDanhGia = resDoiTuongApi.result;
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_tableSearch();
  }
};
</script>
<style lang="scss">
.el-select-dropdown__wrap {
    // max-width: 320px;
}
.el-autocomplete.inline-input{
  width: 100%;
}
</style>
